import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    circle: {
      width: 24,
      height: 24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: COLORS.gray.gray90,
      border: '1.5px solid white',
      borderRadius: '100%',
      marginRight: theme.spacing(-0.5),
    },
    moreTools: {
      fontSize: theme.typography.pxToRem(11),
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
    },
  }),
  { name: 'CardToolsIcons' }
);
